// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const ManageReviewList = () => import('@/modules/reviews/views/management/ManageReviewList')
const ManageReviewSettings = () => import('@/modules/reviews/views/management/ManageReviewSettings')

const ReviewList = () => import('@/modules/reviews/views/ReviewList')
// const ClientReviewDetail = () => import('@/modules/reviews/views/ClientReviewDetail')

var routes = [
    {
        path: '/reviews',
        redirect: '/reviews/manage/list',
        name: 'Manage Reviews',
        component: DefaultContainer,
        children: [
            {
				path: 'manage/list',
                name: 'Manage Reviews List',
                component: ManageReviewList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
				path: 'manage/:review_id',
                name: 'Manage Review Settings',
                component: ManageReviewSettings,
                meta: {
                    requiresAuth: true,
                    permission: false,
                }
            },
			{
				path: ':review_id',
				name: 'Client Review List',
				component: ReviewList,
				meta: {
					requiresAuth: true,
					permission: false,
				}
			},
			// {
			// 	path: ':review_id/client-review/:client_review_id',
			// 	name: 'Client Review Detail',
			// 	component: ClientReviewDetail,
			// 	meta: {
			// 		requiresAuth: true,
			// 		permission: false,
			// 	}
			// },
        ]
    },
];

export default routes;
